// extracted by mini-css-extract-plugin
module.exports = {"container-A":"termofuse_container-A__2eo5h","container":"termofuse_container__2so1c","title":"termofuse_title__2T2zh","content":"termofuse_content__3bQyB"};